import { STOPPED } from '../../../constants/states';

export default {
  reduxState: {
    game: {
      gameState: STOPPED,
      score: 0,
      lines: 0
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/__fixtures__/FlatrisGame/new-game.js